// extracted by mini-css-extract-plugin
export default {"hotelCards":"SearchPage_hotelCards__N6xcg"};